import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const useRespondentChatForTextAnalysis = (activityId) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['respondentChatTextAnalysis', activityId],
        queryFn: () => getRespondentChat(activityId)
    });

    return { data, refetch, isLoading, isError };
};

const getRespondentChat = async (activityId) => {
    const { data } = await vlqrApi.get(`TextAnalysis/${activityId}/RespondentChat`)
        .catch((error) => {
            handleError(error);
        });
    return data;
};

export default useRespondentChatForTextAnalysis;